<template>
	<div class="flex-center download-box1">
      <div class="download-center">
        <div class="title-header">
          <div class="download-title">{{$t('加入 NECO')}}</div>
          <div class="download-info">{{$t('消费创造财富，社区共建共享。')}}</div>
        </div>
        <!-- <div class="download-v">{{$t('当前版本') }}{{vers}}</div> -->
        <div class="flex-around">
          <div class="box-r">
            <img src="../../../../static/image/lobby/ios-icon.png" alt="" @click="ios"></img>
            <div class="download-text">({{$t('全球版')}})</div>
          </div>
          <div class="box-r">
            <img src="../../../../static/image/lobby/an-icon.png" alt="" @click="an">
            <div class="download-text">({{$t('全球版')}})</div>
          </div>
          <!-- <div class="box-r">
            <img src="../../../../static/image/lobby/ios-icon.png" alt="" @click="ios"></img>
            <div class="download-text">({{$t('中国版')}})</div>
          </div>
          <div class="box-r">
            <img src="../../../../static/image/lobby/an-icon.png" alt="" @click="an">
            <div class="download-text">({{$t('中国版')}})</div>
          </div> -->
        </div>
      </div>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	export default {
		computed: mapState({
			screenSize(state) {
				return state.screenSize;
			},
			common(state) {
				return state.common;
			}
		}),
		data() {
			return {
        vers:'0.0.01',
        iosUrl:'',
        androidUrl:''
			}
		},
		mounted() {
    this.getInfo()
      this.$nextTick(() => {

        let colorbg = new Color4Bg.BlurGradientBg({
          dom: 'download-box',
          colors: ['#1D4600', '#152900', '#005232', '#000f07'],
          loop: true
        })
      })

			// this.$nextTick(() => {
      //   let color1bg = new Color4Bg.BlurDotBg({
      //     dom: "helpBox",
      //     colors: ["#801300","#AE1E00","#D92800","#EB3131"],
      //     loop: true
      //   })
			// })

		},
    methods:{
      getInfo(){
        this.$get(this.$apiUtil.getAppVersion).then((res)=>{
          console.log(res)
          this.vers = res.result.androidVersion
          this.iosUrl=res.result.iosDownloadUrl
          this.androidUrl=res.result.androidDownloadUrl
        })
      },
      ios(){
        window.open(this.iosUrl)
        // window.open(process.env.ios)
      },
      an(){
        // window.open(process.env.android)
        window.open(this.androidUrl)
      }
    }
	}
</script>

<style scoped>
	@media screen and (max-width: 768px) {
		.help {
			width: 100% !important;
			padding: 110px 0 60px 0 !important;
			height: calc(100vh - 110px - 60px) !important;
			position: relative;
			z-index: 3;
			display: flex;
			justify-content: space-between;
			align-items: center !important;
			overflow-y: auto;
			overflow-x: hidden;
		}

    .download-center{
      display: flex;
      /*align-items: start!important;*/
      flex-direction: column;
      z-index: 3;
      margin-top: 2rem;
    }
    .download-title{
      font-size: 32px!important;
      color: #fff;
      font-weight: 800;
    }
    .download-info{
      font-size: 20px!important;
      color: #fff;
      font-weight: 800;
      margin: .07rem auto .2rem;
    }
    .download-v{
      height: .44rem;
      padding: 0 .4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100px;
      background: rgba(255, 255, 255, 0.05);
      font-size: 14px!important;
      color: #fff;
      font-weight: 600;
      margin-bottom: .97rem;
    }
    .flex-around{
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 1rem;
      flex-wrap: wrap;
      padding-top: 0 !important;
    }
    .flex-around img{
      width: 150px!important;
      height: 150px!important;
      cursor: pointer;
    }
    .download-center {
      margin-top: 0;
    }
    .title-header {
      text-align: left !important;
      width: 100%;
      padding-bottom: 2rem;
    }
    .download-title {
      text-align: left !important;
    }
	}
    .download-box1 {
        height: 100%;
    }
	.help {
		width: 100%;
		height: 100vh;
		position: relative;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 3;
		display: flex;
		flex-direction: column;
		align-items: center;
		/* justify-content: center; */
		overflow-y: auto;
	}
	.gif-bg {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 2;
	}
  .download-center{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 3;
  }
  .download-title{
    font-size: .96rem;
    color: #fff;
    font-weight: 800;
    text-align: center;
  }
  .download-info{
    font-size: .36rem;
    color: #fff;
    font-weight: 800;
    margin: .07rem auto .2rem;
  }
  .download-v{
    height: .44rem;
    padding: 0 .4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    background: rgba(255, 255, 255, 0.05);
    font-size: .16rem;
    color: #fff;
    font-weight: 600;
    margin-bottom: .97rem;
  }
  .flex-around{
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 1rem;
    padding-top: 1rem;
  }
  .flex-around img{
    width: 2rem;
    height: 2rem;
    cursor: pointer;
  }
  .box-r {
    position: relative;
  }
  .download-text {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 0.2rem;
    right: 0;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.5);
  }



</style>



// WEBPACK FOOTER //
// src/components/lobby/components1030/view12.vue